<template>
  <div class="scroll-wrapper">
    <div class="scheduler-page">
      <el-tabs v-model="activeTab" class="tabs">
      <el-tab-pane label="Текущие смены" name="current">
        <el-skeleton :loading="isLoading" animated>
          <template #default>
            <shift-table
              :type="activeTab"
              :users="schedules"
              :loading="isLoading"
              @update-shifts="onUpdateShifts"
              @delete-shifts="onDeleteShifts"
            />
          </template>
        </el-skeleton>
        <el-button
          type="primary"
          class="create-shift-btn"
          @click="scheduleDialogVisible = true">Создать смену</el-button>
      </el-tab-pane>
      <el-tab-pane label="История смен" name="history">
        <el-skeleton :loading="isLoading" animated>
          <template #default>
            <shift-table
              :type="activeTab"
              :users="schedules"
              :loading="isLoading"
            />
          </template>
        </el-skeleton>
      </el-tab-pane>
      <el-tab-pane label="Шаблоны смен" name="templates">
        <shift-template-manager />
      </el-tab-pane>
    </el-tabs>

      <create-schedule-dialog
        v-model="scheduleDialogVisible"
      />
    </div>
  </div>
</template>
<script>
import ShiftTable from '@/components/util/scheduler/ShiftTable.vue'
import CreateScheduleDialog from '@/components/util/scheduler/CreateScheduleDialog.vue'
import ShiftTemplateManager from '@/components/util/scheduler/ShiftTemplateManager.vue'
import { mapActions, mapState } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'SchedulerPage',
  components: {
    ShiftTable,
    CreateScheduleDialog,
    ShiftTemplateManager
  },
  data() {
    return {
      activeTab: 'current',
      scheduleDialogVisible: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState('schedules', ['schedules'])
  },
  created() {
    this.isLoading = true;
    this.getUsers();
    this.getCities();
    this.loadSchedules();
  },
  watch: {
    activeTab() {
      this.loadSchedules();
    }
  },
  methods: {
    ...mapActions('schedules', ['fetchSchedules', 'updateSchedule', 'deleteSchedule']),
    ...mapActions('users', ['getUsers']),
    ...mapActions('cities', ['getCities']),
    async loadSchedules() {
      this.isLoading = true;
      await this.fetchSchedules({ type: this.activeTab });
      this.isLoading = false;
    },
    async onUpdateShifts(user) {
      try {
        const payload = {
          user_id: user.id,
          city_id: user.city_id,
          branch_id: user.branch_id,
          room_id: user.room_id,
          shifts: (user.shifts || []).map(shift => ({
            date: shift.date,
            start_time: shift.start_time,
            end_time: shift.end_time,
            breaks: Array.isArray(shift.breaks)
              ? shift.breaks.map(b => ({
                type: b.type,
                start: b.start || b.start_time,   // ← добавили fallback
                end: b.end || b.end_time,
                date: shift.date
              }))
              : []
          }))
        };

        console.log('Отправка данных на сервер:', payload);
        await this.$store.dispatch('schedules/updateSchedule', payload);
        ElMessage.success('Смены успешно обновлены');
      } catch (error) {
        console.error('Ошибка при обновлении смен:', error);
        ElMessage.error('Ошибка при обновлении смен');
      }
    },
    async onDeleteShifts(user) {
      try {
        await ElMessageBox.confirm(
          `Удалить все смены для сотрудника ${user.name}?`,
          'Подтверждение удаления',
          {
            confirmButtonText: 'Удалить',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }
        );
        await this.deleteSchedule({
          user_id: user.id,
          city_id: user.city_id,
          branch_id: user.branch_id,
          room_id: user.room_id
        });
        ElMessage.success('Смены успешно удалены');
        this.loadSchedules();
      } catch {
        ElMessage.info('Удаление отменено');
      }
    }
  }
}
</script>



<style scoped>
.scheduler-page {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  padding: 20px 26px;
  color: var(--cal-text-inverse);
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.create-shift-btn {
  margin: 10px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  width: 156px;
  min-height: 40px;
  padding: 0 18px;
  border-radius: 9px;
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
}

.tabs {
  margin-bottom: 20px;
}

.create-shift-btn {
  background: var(--appointment-primary) !important;
  border-color: transparent !important;
  color: var(--appointment-primary-text) !important;
}

:deep(.tabs .el-tabs__header) {
  margin-bottom: 22px;
}

:deep(.tabs .el-tabs__item) {
  padding: 0 22px 0 0;
  color: var(--cal-text-regular);
  font-size: 14px;
}

:deep(.tabs .el-tabs__item.is-active),
:deep(.tabs .el-tabs__item:hover) {
  color: var(--cal-accent) !important;
}

:deep(.tabs .el-tabs__active-bar) {
  background-color: var(--cal-accent);
  height: 1px;
}

:deep(.tabs .el-tabs__nav-wrap::after) {
  background-color: transparent;
}

@media (max-width: 768px) {
  .scheduler-page {
    padding: 12px 12px;
  }
  .create-shift-btn {
    width: 156px;
    min-height: 40px;
    padding: 0 18px;
    font-size: 14px;
    border-radius: 8px;
  }
  :deep(.tabs .el-tabs__header) {
    margin-bottom: 16px;
  }
  :deep(.tabs .el-tabs__nav-wrap) {
    overflow-x: auto !important;
    scrollbar-width: none;
  }
  :deep(.tabs .el-tabs__nav-wrap::-webkit-scrollbar) {
    display: none;
  }
  :deep(.tabs .el-tabs__nav-scroll) {
    overflow: visible !important;
  }
  :deep(.tabs .el-tabs__nav) {
    display: inline-flex;
    flex-wrap: nowrap;
    min-width: max-content;
  }
  :deep(.tabs .el-tabs__item) {
    font-size: 13px !important;
    padding: 0 14px 0 0 !important;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .scheduler-page {
    padding: 8px 10px;
  }
  .create-shift-btn {
    min-height: 38px;
    padding: 0 14px;
    font-size: 13px;
    width: 180px;
    max-width: 100%;
    margin-top: 14px;
  }
  :deep(.tabs .el-tabs__item) {
    font-size: 12px !important;
    padding: 0 10px 0 0 !important;
  }
}

:deep(.tabs .el-tabs__item) {
  transition: color 0.2s;
}
</style>
